import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useDirectorActions, useDirectorContext } from "@contexts/director";

// Mantém a obra da URL (`:project_key`) e o filtro "Obra" do cabeçalho da Diretoria em sincronia.
// A URL manda quando a tela abre; depois, trocar a obra no cabeçalho navega para a tela dela.
const useProjectRoute = ({ routeKey = null, pathFor }) => {
  const { filters = {} } = useDirectorContext();
  const actions = useDirectorActions();
  const navigate = useNavigate();
  const synced = useRef(null);
  const contextKey = filters.projectKey || null;
  const pathForRef = useRef(pathFor);
  pathForRef.current = pathFor;
  const actionsRef = useRef(actions);
  actionsRef.current = actions;
  const previousContext = useRef(undefined);

  useEffect(() => {
    const changed = previousContext.current !== contextKey;
    previousContext.current = contextKey;
    if (!routeKey) synced.current = null;
    if (routeKey && synced.current !== routeKey) {
      synced.current = routeKey;
      if (contextKey !== routeKey) {
        actionsRef.current?.setFilters?.({ legalEntityId: null, projectKey: routeKey, costCenterId: null });
      }
      return;
    }
    if (changed && contextKey !== routeKey) navigate(pathForRef.current(contextKey), { replace: true });
  }, [contextKey, navigate, routeKey]);

  const clearProject = () => actions?.setFilters?.({
    legalEntityId: null,
    projectKey: null,
    costCenterId: null,
  });

  return { clearProject };
};

export default useProjectRoute;
